import { render } from "./PlaceholderWrapper.vue?vue&type=template&id=5c76fd65"
import script from "./PlaceholderWrapper.vue?vue&type=script&lang=js"
export * from "./PlaceholderWrapper.vue?vue&type=script&lang=js"

import exportComponent from "./node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__